import { render, staticRenderFns } from "./WikiRedirectedPageList.vue?vue&type=template&id=2c65b7e2"
import script from "./WikiRedirectedPageList.vue?vue&type=script&lang=ts"
export * from "./WikiRedirectedPageList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports